import React, { useContext, useState } from "react";
import { Stack, Typography, Card, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as FileCheckIcon } from "../assets/images/file_check_fill.svg";
import { ReactComponent as LoanIcon } from "../assets/images/loanIcon.svg";
import { ReactComponent as PdfIcon } from "../assets/images/pdfIcon.svg";
import { ReactComponent as TransferIcon } from "../assets/images/transferIcon.svg";
import { Phone, ArrowForwardIos, MailOutline } from "@mui/icons-material";
import * as api from "../api/MyHome";
import { Button, Checkbox, Modal } from "@mui/material";
import { DisclaimerContext } from "../contexts/DisclaimerContext.js";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PinchToZoomAndPanImage from "./PinchToZoomAndPanImage.js";
import { checkProductType } from '../utils/checkProductType';

export const CardMenu = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const chooseIcon = {
    fileCheckIcon: <FileCheckIcon fill={theme.palette.primary.contrastText} />,
    loanIcon: <LoanIcon fill={theme.palette.primary.contrastText} />,
    pdfIcon: <PdfIcon fill={theme.palette.primary.contrastText} />,
    transferIcon: <TransferIcon fill={theme.palette.primary.contrastText} />,
    phoneIcon: <Phone sx={{ color: theme.palette.primary.contrastText }} />,
    mailIcon: (
      <MailOutline sx={{ color: theme.palette.primary.contrastText }} />
    ),
  };
  const [disclaimerData, setDisclaimerData] = useState(null);
  const [description, setDescription] = useState("");
  const [isFunction, setIsFunction] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAlertDisclaimer, setIsAlertDisclaimer] = useState(false);
  const [checkDisclaimerLog, setCheckDisclaimerLog] = useState(false);
  const [showTextReminder, setShowTextReminder] = useState(false);

  const disclaimerlogContext = useContext(DisclaimerContext);

  const navigateByPath = async (path) => {
    let current_path = location.pathname.slice(1);
    let profile_lineOA = JSON.parse(localStorage.getItem("profile_lineOA"));
    let getCompanyId = profile_lineOA.cid
    let result = await api.middleWareDisclaimer({
      urlName: path,
      currentUrl: current_path,
      company_id: Number(getCompanyId),
    });
    let data = result?.data?.data;

    console.log(profile_lineOA)

    if (data === null || result?.data?.message === "disclaimer not found" || data?.status === "false") {
      return navigate(props?.navigate + location.search, {
        state: props?.state,
      })
    }

    // let disclaimerIdIsExist = disclaimerlogContext.state?.id.find((ele) => 
    //   ele === data?.id && navigate(props?.navigate + location.search, {
    //     state: props?.state,
    //   })
    // );
    // await disclaimerIdIsExist
    console.log(checkProductType(), "disclaimerlogContext.state?.id")
    const isAcceptData = await api.getIsAcceptDisclaimer({
      company_id: Number(getCompanyId),
      line_id: profile_lineOA.profile.userId,
      master_disclaimer_id: result?.data?.data?.id,
      product_type: checkProductType(),
    })

    console.log(isAcceptData, "isAcceptData?.data?.data?.is_accept")


    if (data?.status === "true" && (data?.is_updated === true || isAcceptData?.data?.data?.is_accept === false)) {
      setDescription(data.description);
      if (data.pictures && Array.isArray(data.pictures)) {
        data.pictures = data.pictures.map((picture) => ({
          id: picture.id ? picture.id.toString() : `new-${Math.random()}`,
          name: picture.name,
          url: picture.path,
        }));
      }

      setDisclaimerData(data);
      data.is_function ? setIsFunction(true) : setIsFunction(false);
      console.log(data, current_path, "data");
      if (data?.current_path === current_path && data?.next_path === path) {
        setIsAlertDisclaimer(true);
      }
    } else {
      return navigate(props?.navigate + location.search, {
        state: props?.state,
      });
    }
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + disclaimerData?.pictures.length) %
        disclaimerData?.pictures.length
    );
  };

  const handleNext = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % disclaimerData?.pictures.length
    );
  };

  const isAcceptDisclaimerLog = async () => {

    let profile_lineOA = localStorage.getItem("profile_lineOA");
    let line_session = JSON.parse(profile_lineOA);
    let getCustomerName = JSON.parse(localStorage.getItem("houseInfoSelected"))

    let req = {
      master_disclaimer_id: disclaimerData.id,
      user_id: line_session.profile.userId,
      accept_at: new Date(),
      username: getCustomerName.customer_name ? getCustomerName.customer_name : getCustomerName.customer_name_en,
      menu: disclaimerData.title,
      company_id: Number(line_session.cid) || Number(line_session.cid_pm) || Number(line_session.cid_rental),
    };
    disclaimerlogContext.dispatch({
      type: "SET_DISCLAIMER",
      payload: disclaimerData?.id,
    });

    await api
      .insertDisclaimerLog(req)
      .then((res) => {
        if (res?.status === 200) {
          api.updateDisclaimer({
            id: disclaimerData.id,
            accept_at: new Date(),
            is_updated: false,
            company_id: Number(line_session.cid) || Number(line_session.cid_pm) || Number(line_session.cid_rental),
          })
          return navigate(props.navigate + location.search);
        }
      })
      .catch((err) => console.log(err));
  };

  const onClear = () => {
    setIsAlertDisclaimer(false);
    setShowTextReminder(false);
    setCheckDisclaimerLog(false);
  };

  return (
    <>
      <Card
        variant="outlined"
        hidden={props?.hidden ? props?.hidden : false}
        onClick={
          props?.onClick
            ? props?.onClick
            : () => {
              if (props?.navigate) {
                navigateByPath(props?.navigate);
                // navigate(props?.navigate + location.search, {
                //   state: props?.state,
                // });
              }
            }
        }
        sx={{
          p: 2,
          boxShadow: "0px 0px 7px 0px #00000040",
          borderRadius: "10px",
        }}
      >
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <div
              style={{
                minHeight: "50px",
                minWidth: "50px",
                textAlign: "center",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                border: "1px",
                boxShadow: "5px 5px 7px 0px #00000040",
                borderRadius: 100,
                backgroundColor: theme.palette.primary.main,
              }}
            >
              {chooseIcon[props?.iconImg]}
            </div>

            <Typography
              variant="body2"
              sx={{ color: theme.palette.primary.main }}
            >
              {props?.text}
            </Typography>
          </Stack>
          <ArrowForwardIos
            sx={{ fontSize: "20px" }}
            fill={theme.palette.primary.main}
          />
        </Stack>
      </Card>
      {isAlertDisclaimer && (

        <Modal open={isAlertDisclaimer} onClose={!isAlertDisclaimer}>
          <Box className="disclaimer-container">
            <Box
              className={`${disclaimerData.pictures.length > 0
                ? "disclaimer-body-photo"
                : "disclaimer-body-photo-hidden"
                }`}
            >
              <div style={{ overflow: "scroll", width: "100%", height: "100%" }}>
                <PinchToZoomAndPanImage
                  src={disclaimerData?.pictures?.length > 0
                    ? disclaimerData.pictures[currentIndex].url
                    : ""}
                />
              </div>
              <ChevronLeftIcon
                onClick={handlePrev}
                style={{
                  fontSize: "30px",
                  color: "#fff",
                  cursor: "pointer",
                  backgroundColor: "rgb(25, 148, 106)",
                  borderRadius: "50%",
                  position: "absolute",
                  left: 0,
                  top: "50%"
                }}
              />
              <ChevronRightIcon
                onClick={handleNext}
                style={{
                  fontSize: "30px",
                  color: "#fff",
                  cursor: "pointer",
                  backgroundColor: "rgb(25, 148, 106)",
                  borderRadius: "50%",
                  position: "absolute",
                  right: 0,
                  top: "50%"
                }}
              />
            </Box>
            <Box className="disclaimer-body-container">
              <p className="disclaimer-body-text">{description}</p>

              <div hidden={isFunction ? false : true}>
                <Checkbox
                  style={{
                    marginLeft: "1.5rem",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onClick={(e) => {
                    if (e.target.checked) {
                      setCheckDisclaimerLog(true);
                    } else {
                      return null;
                    }
                  }}
                  disabled={checkDisclaimerLog ? true : false}
                />
                ตกลงและยอมรับเงื่อนไข
              </div>
              {showTextReminder && (
                <p
                  style={{
                    color: "red",
                    marginLeft: "1.5rem",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  *กรุณายอมรับเงื่อนไขก่อน
                </p>
              )}
              <div className="disclaimer-body-footer">
                <div
                  className="button-container"
                  hidden={isFunction ? false : true}
                >
                  <Button
                    onClick={() => onClear()}
                    style={{
                      backgroundColor: "white",
                      color: "#19946a",
                      border: "1px solid #19946a",
                      marginRight: "1rem",
                    }}
                  >
                    ยกเลิก
                  </Button>
                  <Button
                    onClick={() => {
                      if (checkDisclaimerLog) {
                        isAcceptDisclaimerLog();
                      } else {
                        setShowTextReminder(true);
                      }
                    }}
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "1px solid #19946a",
                    }}
                  >
                    ยืนยัน
                  </Button>
                </div>
                <div
                  hidden={isFunction ? true : false}
                  className="button-container"
                >
                  <Button
                    onClick={() => {
                      let disclaimerIdIsExist =
                        disclaimerlogContext.state?.id.find(
                          (ele) => ele === disclaimerData?.data?.id
                        );
                      if (disclaimerIdIsExist) {
                        return navigate(props.navigate);
                      } else {
                        disclaimerlogContext.dispatch({
                          type: "SET_DISCLAIMER",
                          payload: disclaimerData?.id,
                        });
                      }
                    }}
                    type="primary"
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      border: "1px solid #19946a",
                    }}
                  >
                    ปิด
                  </Button>
                </div>
              </div>
            </Box>
          </Box>
        </Modal>
      )}
    </>

  );
};
